<h2 mat-dialog-title>Choose cashout method</h2>
<mat-dialog-content>
    <mat-radio-group
        class="method-grid"
        [(ngModel)]="selectedMethod"
        aria-label="Cashout method"
    >
        <label
            class="method-card"
            [class.disabled]="isMethodDisabled('instant')"
            [class.unavailable]="!isMethodAvailable('instant')"
            [class.selected]="selectedMethod === 'instant'"
        >
            <span class="method-title">
                <img
                    src="/assets/images/instant.png"
                    alt="Instant"
                    class="instant-method-img"
                />
                Instant Pay
            </span>
            <p class="method-desc">Get paid in minutes</p>
            <p class="method-desc">{{ formatAmount(data?.instantFeeAmount || 1.25) }} fee</p>
            <mat-radio-button
                class="method-radio"
                value="instant"
                [disabled]="isMethodDisabled('instant')"
            >
            </mat-radio-button>
        </label>
        <label
            class="method-card"
            [class.disabled]="isMethodDisabled('standard')"
            [class.unavailable]="!isMethodAvailable('standard')"
            [class.selected]="selectedMethod === 'standard'"
        >
            <span class="method-title">Standard Pay</span>
            <p class="method-desc">3-5 business days</p>
            <p class="method-desc">No fee</p>
            <mat-radio-button
                class="method-radio"
                value="standard"
                [disabled]="isMethodDisabled('standard')"
            ></mat-radio-button>
        </label>
    </mat-radio-group>

    <div class="amount-summary">
        <div class="amount-row">
            <span class="label">Total</span>
            <span class="value">
                {{ formatAmount(data?.totalAmount || 0) }}
            </span>
        </div>
        <div class="amount-row fee-row" *ngIf="selectedMethod === 'instant'">
            <span class="label">Instant Fee Amount</span>
            <span class="value">
                {{ formatAmount(data?.instantFeeAmount || 0) }}
            </span>
        </div>
        <div class="amount-row">
            <span class="label">Transfer Amount</span>
            <span class="value">
                {{ formatAmount(getTransferAmount()) }}
            </span>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button
        mat-button
        class="btn btn-pink"
        id="choose-cashout-method-cancel-button"
        mat-dialog-close
    >
        Cancel
    </button>
    <button
        mat-button
        class="btn btn-pink-filled"
        id="choose-cashout-method-proceed-button"
        (click)="proceed()"
        [disabled]="isProceedDisabled()"
    >
        Proceed
    </button>
</mat-dialog-actions>
